import { useStore } from "..";
export const useTag = () => useStore(({ tag }) => tag);
